import { styled } from 'styled-components';
import { METRIC_MODAL_HEIGHTS } from './MetricModal.constants';

export const MetricModalContent = styled.div`
  width: 50vw;
  max-width: 450px;
  height: ${METRIC_MODAL_HEIGHTS.BODY}px;
`;
MetricModalContent.displayName = 'MetricModalContent';

export const ModalSearchHolder = styled.div`
  > div {
    width: 100%;
  }

  margin: ${({ theme }) => theme.sizing.medium} 0
    ${({ theme }) => theme.sizing.small} 0;
`;
ModalSearchHolder.displayName = 'ModalSearchHolder';

export const InfoLine = styled.div`
  margin-top: ${({ theme }) => theme.sizing.small};
  display: table;

  & span {
    ${({ theme }) => theme.typography.bodyRegular}
  }

  & > span:first-child {
    ${({ theme }) => theme.typography.bodySmall}
    width: 120px;
    text-align: right;
    display: inline-block;
    margin-right: ${({ theme }) => theme.sizing.small};
  }
`;
InfoLine.displayName = 'InfoLine';

export const ModalMetricHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
ModalMetricHeader.displayName = 'ModalMetricHeader';

export const MetricModalCheckboxContainer = styled.div`
  > div > div {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: ${({ theme }) => theme.sizing.medium};
    padding: ${({ theme }) => theme.sizing.small} 0 0
      ${({ theme }) => theme.sizing.small};
  }
`;
MetricModalCheckboxContainer.displayName = 'MetricModalCheckboxContainer';

export const MetricModalItem = styled.div`
  display: flex;
  flex-direction: row;

  > div:first-child > span:first-child {
    margin-right: ${({ theme }) => theme.sizing.small};
  }

  > div:first-child {
    align-items: flex-start;
  }

  &:hover {
    cursor: pointer;
  }
`;
MetricModalItem.displayName = 'MetricModalItem';

export const MetricModalItemLabel = styled.div`
  ${({ theme }) => theme.typography.bodySmall}

  span {
    display: block;
  }

  span:first-child {
    ${({ theme }) => theme.typography.bodyMedium}
  }
`;
MetricModalItemLabel.displayName = 'MetricModalItemLabel';

export const MetricModalAdjuster = styled.div`
  dialog {
    > div {
      max-height: calc(100vh - 15rem);
      overflow-y: auto;
      scrollbar-gutter: stable;
      margin-right: ${({ theme }) => theme.sizing.small};
    }
  }
`;
MetricModalAdjuster.displayName = 'MetricModalAdjuster';

export const MetricModalStatusWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  vertical-align: bottom;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.tiny};

  svg {
    color: ${({ theme }) => theme.colours.messaging.info.main};
  }
`;
MetricModalStatusWrapper.displayName = 'MetricModalStatusWrapper';
